import {
    ATTR_SERVICE_NAME,
    ATTR_SERVICE_VERSION,
    ATTR_USER_AGENT_ORIGINAL
  } from '@opentelemetry/semantic-conventions';
import { initResource } from './resource';
import { setupTracing } from './instrumentation';
import { getBrowserDetails } from '../../comman/status';
const userAgent = window.navigator.userAgent;


let  browserInfo = getBrowserDetails()
type OtelConfig = {
    env: string, 
    version: string
    name: string
}
var serviceName,env,version = 'undefined' ; 

export function InitOtel(params: OtelConfig) {
    console.log('InitOtel',params)
    serviceName = params.name
    env = params.env
    version = params.version
    initResource({
      [ATTR_SERVICE_NAME]: serviceName,
      [ATTR_SERVICE_VERSION]: version,
      [ATTR_USER_AGENT_ORIGINAL]: userAgent,
      'env': env,
      'os': browserInfo.OSName,
      'browser': browserInfo.browserName,
      'browserVersion': browserInfo.fullVersion
    });
    setupTracing()
}

